import React from 'react';
import { useTranslation } from 'react-i18next';
import { KpiTile } from '../patterns';
import type { ScoutingKpis } from '../../utils/scoutingDashboardMath';

interface Props {
  kpis: ScoutingKpis;
}

export const ScoutingKpiRow: React.FC<Props> = ({ kpis }) => {
  const { t } = useTranslation();
  const percent = kpis.totalOrchards === 0
    ? 0
    : Math.round((kpis.upToDate / kpis.totalOrchards) * 100);
  const yellowOnly = kpis.pending - kpis.overdue;
  return (
    <div className="pat-kpi-row">
      <KpiTile
        primary
        label={t('dashboard.scouting.kpi.upToDate')}
        value={`${kpis.upToDate} / ${kpis.totalOrchards}`}
        delta={t('dashboard.scouting.kpi.upToDateDelta', { percent })}
      />
      <KpiTile
        label={t('dashboard.scouting.kpi.pending')}
        value={kpis.pending}
        delta={t('dashboard.scouting.kpi.pendingDelta', { yellow: yellowOnly, red: kpis.overdue })}
      />
      <KpiTile
        label={t('dashboard.scouting.kpi.inspectionPts')}
        value={kpis.inspectionPoints}
        delta={t('dashboard.scouting.kpi.inspectionPtsDelta', { scouters: kpis.scouterCount })}
      />
      <KpiTile
        label={t('dashboard.scouting.kpi.overdue')}
        value={kpis.overdue}
        delta={t('dashboard.scouting.kpi.overdueDelta')}
        alert={kpis.overdue > 0}
      />
    </div>
  );
};
